<template>
	<div style="margin-top:30px;text-align:center">
        <v-icon name="hourglass-half" scale="2"  style="color:#a0a0a0;opacity:1"/>
        <p style="margin-top:15px;color:#a0a0a0;font-size:1.3em;">Les résultats sont en attente de publication. Revenez plus tard...</p>
    </div>
</template>

<script>
export default {
	components:{},

  data () {
    return {
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/component/Epreuve/AttenteResultats.vue